<div class="uk-section uk-section-primary uk-preserve-color uk-text-center">
  <div class="uk-container uk-container-center">

<!--    <div class="uk-flex uk-flex-center">-->
<!--      <div class="uk-flex uk-flex-middle uk-text-primary" style="background-color: #DAEEF3; border-radius: 50px; padding: 6px 12px">-->
<!--        <span class="" style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">-->
<!--          New feature-->
<!--        </span>-->
<!--        <span class="uk-margin-small-left uk-flex uk-flex-middle">-->
<!--          Check out our new feature-->
<!--          <span class="material-icons uk-margin-small-left uk-text-primary">arrow_forward</span>-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->

    <div class="uk-flex uk-flex-center">
      <div class="uk-flex uk-flex-middle uk-text-primary" style="background-color: #DAEEF3; border-radius: 50px; padding: 6px 12px">
        <a [routerLink]="['/about/news']" class="uk-link-reset">
          <span class="uk-margin-small-left uk-flex uk-flex-middle">
            Join us for the launch event of the EOSC Open Science Observatory
            <span class="material-icons uk-margin-small-left uk-text-primary">arrow_forward</span>
          </span>
        </a>
      </div>
    </div>

    <h1>Monitoring the European Open Science Cloud (EOSC)</h1>
    <p>The EOSC Open Science Observatory offers a all-inclusive platform where you can access, explore, visualize and download comprehensive data on the advancement of Open Science (OS) across Europe.</p>

    <h3>Explore</h3>
    <div class="uk-child-width-1-1@s uk-child-width-1-3@m uk-grid-match uk-flex-center uk-grid-row-medium" uk-grid uk-height-match="target: > div > a > .uk-card">

      <div>
        <a [routerLink]="['/explore/open-science-by-area']" class="text-black uk-link-reset">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/OS%20by%20Area.svg" style="width: 71px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">category</span>-->
            <div class="uk-margin-left">
              <h5>Open Science by Area</h5>
              <p>Search data on Open Access publications, Open software,  infrastructure, training, and more. </p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a class="text-black custom-disabled-link uk-link-reset" uk-tooltip="Coming soon..">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/Open%20Science%20by%20country.svg" style="width: 31px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">flag</span>-->
            <div class="uk-margin-left">
              <h5>Open Science by Country</h5>
              <p>Compare OS initiatives across Europe, country by country.</p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a [routerLink]="['/explore/open-science-trends']" class="text-black uk-link-reset">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/Open%20Science%20Trends.svg" style="width: 31px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">trending_up</span>-->
            <div class="uk-margin-left">
              <h5>Open Science Trends</h5>
              <p>Track the latest patterns and shifts in OS across Europe.</p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a [routerLink]="['/explore/investments-in-eosc']" class="text-black uk-link-reset">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/Investment%20EOSC.svg" style="width: 71px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">euro</span>-->
            <div class="uk-margin-left">
              <h5>Investments in EOSC</h5>
              <p>With lots of unique blocks, you can easily build a page without coding. Build your next landing page.</p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a [routerLink]="['/explore/national-monitoring']" class="text-black uk-link-reset">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/OPen%20Science%20Monitoring.svg" style="width: 41px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">monitoring</span>-->
            <div class="uk-margin-left">
              <h5>Open Science Monitoring</h5>
              <p>Access data on national monitoring initiatives of EOSC and OS.</p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a class="text-black custom-disabled-link uk-link-reset" uk-tooltip="Coming soon..">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/Open%20Science%20Use%20Cases.svg" style="width: 41px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">data_usage</span>-->
            <div class="uk-margin-left">
              <h5>Open Science Use Cases</h5>
              <p>Discover practical OS use cases from various disciplines.</p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a [routerLink]="['/explore/open-science-policies']" class="text-black uk-link-reset">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/Open%20Science%20Policies.svg" style="width: 41px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">policy</span>-->
            <div class="uk-margin-left">
              <h5>Open Science Policies</h5>
              <p>Examine OS policies at national, financial, RPO, and RFO levels.</p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a class="text-black custom-disabled-link uk-link-reset" uk-tooltip="Coming soon..">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/Open%20Science%20Resource%20Registryu.svg" style="width: 41px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">database</span>-->
            <div class="uk-margin-left">
              <h5>Open Science Resource Registry</h5>
              <p>Explore full texts of strategies, policies, and other OS documents. from countries </p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a class="text-black custom-disabled-link uk-link-reset" uk-tooltip="Coming soon..">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/OPen%20Science%20Impact.svg" style="width: 41px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">earthquake</span>-->
            <div class="uk-margin-left">
              <h5>Open Science Impact</h5>
              <p>Assess the impact of OS initiatives—detailed insights coming soon.</p>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a class="text-black custom-disabled-link uk-link-reset" uk-tooltip="Coming soon..">
          <div class="uk-card card-explore uk-card-small uk-card-body uk-flex">
            <span>
              <img src="assets/images/explore/Create%20your%20own%20search.svg" style="width: 41px; height: 33px">
            </span>
<!--            <span class="material-symbols-outlined filled uk-text-primary">tune</span>-->
            <div class="uk-margin-left">
              <h5>Create your own search</h5>
              <p>Customize your search to uncover specific OS data and trends.</p>
            </div>
          </div>
        </a>
      </div>

    </div>
  </div>
</div>

<!--<div class="uk-section uk-section-default uk-preserve-color uk-padding-remove" uk-height-viewport="offset-top: true; offset-bottom: 20;">-->

<!--  <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-2@m uk-child-width-1-2@l">-->
<!--    <div class="uk-flex-last@m uk-flex-last@l">-->
<!--      <img src="../../assets/images/1-2.png">-->
<!--    </div>-->
<!--    <div class="uk-first-column">-->
<!--      <div class="uk-padding-large uk-margin-large-left@m uk-margin-large-left@l uk-margin-large-top">-->
<!--        <h1>Monitoring the European Open Science Cloud (EOSC)</h1>-->
<!--        <p class="big-text uk-margin-medium-top">The EOSC Observatory is <span class="uk-text-primary">a policy intelligence tool</span>-->
<!--          being developed by the EOSC Future project for monitoring policies,  practices, and impacts related to the-->
<!--          European Open Science Cloud (EOSC). It will support the EOSC community in tracking the implementation of EOSC-->
<!--          and the policy makers in developing actionable policies.</p>-->
<!--        <a class="uk-button uk-button-primary uk-margin-medium-top" [routerLink]="['/eoscreadiness']">Explore the EOSC Observatory</a>-->
<!--      </div>-->

<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--<div class="uk-section uk-section-default uk-preserve-color uk-margin-large-top">-->
<!--  <div class="uk-container uk-container-xlarge">-->

<!--    <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-2@m uk-child-width-1-2@l">-->
<!--      <div>-->
<!--        <h1>EOSC Monitoring Ecosystem</h1>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="uk-margin-medium-top">-->
<!--      <p>-->
<!--        The implementation and uptake of EOSC is being monitored in varying capacities and by various stakeholders at institutional,-->
<!--        national, and European levels. Four key monitoring activities can be identified by the EOSC Steering Board, EOSC Association,-->
<!--        and EOSC Ecosystem which are being implemented via data collection surveys-->
<!--      </p>-->
<!--    </div>-->

<!--    <div class="uk-grid uk-child-width-1-4 uk-grid-match uk-margin-large-top uk-grid-medium">-->

<!--      <div>-->
<!--        <div class="uk-card uk-card-default uk-card-body">-->
<!--          <a [routerLink]="['/eoscreadiness']">-->
<!--            <div><img src="../../assets/images/icons/number1.svg" width="100"></div>-->
<!--            &lt;!&ndash;          <div class="big-number uk-text-secondary uk-text-bolder">1</div>&ndash;&gt;-->
<!--            <p class="primary-card-header">Indicators to Monitor EOSC Readiness</p>-->
<!--            <p>The EOSC Steering Board has developed indicators to monitor the EOSC readiness of countries in Europe via an-->
<!--              annual survey on National Contributions to EOSC</p>-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div class="uk-card uk-card-default uk-card-body" style="opacity: 0.4">-->
<!--          <div><img src="../../assets/images/icons/number2.svg" width="97"></div>-->
<!--&lt;!&ndash;          <div class="big-number uk-text-bolder">2</div>&ndash;&gt;-->
<!--          <p class="primary-card-header">Indicators to Monitor EOSC Partnership</p>-->
<!--          <p>The EOSC Association has developed indicators to monitor the implementation of the EOSC Partnership by members-->
<!--            via an annual survey on Key Performance Indicators</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div class="uk-card uk-card-default uk-card-body" style="opacity: 0.4">-->
<!--&lt;!&ndash;          <div class="big-number uk-text-bolder">3</div>&ndash;&gt;-->
<!--          <div><img src="../../assets/images/icons/number3.svg" width="95"></div>-->
<!--          <p class="primary-card-header">Contributions to EOSC Partnership</p>-->
<!--          <p>The EOSC Association will monitor the financial and in-kind contributions to the EOSC Partnership by members-->
<!--            via an annual survey on the Additional Activities Plan</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div class="uk-card uk-card-default uk-card-body" style="opacity: 0.4">-->
<!--&lt;!&ndash;          <div class="big-number uk-text-secondary uk-text-bolder">4</div>&ndash;&gt;-->
<!--          <div><img src="../../assets/images/icons/number4.svg" width="90"></div>-->
<!--          <p class="primary-card-header">Policies Relevant for EOSC Ecosystem</p>-->
<!--          <p>Various stakeholders in the EOSC ecosystem (including projects and experts) are monitoring the implementation-->
<!--            and uptake of EOSC via surveys on policies relevant for EOSC</p>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->


<!--  </div>-->
<!--</div>-->

<!--<div class="uk-section uk-section-default uk-preserve-color uk-margin-large-top">-->
<!--  <div class="uk-container uk-container-xlarge">-->

<!--    <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-2@m uk-child-width-1-2@l">-->
<!--      <div>-->
<!--&lt;!&ndash;        <div class="h1-subHeader">How it works</div>&ndash;&gt;-->
<!--        <h1>EOSC Observatory Dashboard</h1>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="uk-grid uk-child-width-1-2 uk-grid-match uk-margin-large-top">-->

<!--      <div class="uk-padding-large">-->
<!--        <img src="../../assets/images/ipad%20mockup.png">-->
<!--      </div>-->

<!--      <div class="uk-padding-xlarge">-->
<!--        <p>The EOSC Observatory consists of an interactive dashboard for users to visualise and exploit data collected by-->
<!--          surveys on the implementation and uptake of EOSC in Europe. The EOSC Observatory currently presents data on the-->
<!--          EOSC readiness of countries from the survey on National Contributions to EOSC 2021 for the EOSC Steering Board-->
<!--        </p>-->
<!--      </div>-->

<!--    </div>-->


<!--  </div>-->
<!--</div>-->

<!--<div class="uk-section uk-section-default uk-preserve-color uk-text-center uk-margin-large-top">-->
<!--  <div class="uk-container uk-container-xlarge">-->

<!--    <div class="h1-subHeader-primary">Coming soon</div>-->
<!--    <h1>EOSC Observatory Country Pages</h1>-->

<!--    <div class="uk-grid uk-margin-medium-top">-->
<!--      <div class="uk-width-1-4"></div>-->
<!--      <div class="uk-width-1-2">-->
<!--        <p>-->
<!--          The EOSC Observatory will not only provide an interactive dashboard to exploit survey data collected by key EOSC-->
<!--          stakeholders, but will also provide country pages that present the updated state-of-play, key statistics, and relevant-->
<!--          contacts and links for EOSC for each country. The country pages are being developed by EOSC Future and are coming soon!-->
<!--        </p>-->
<!--      </div>-->
<!--      <div class="uk-width-1-4"></div>-->
<!--    </div>-->

<!--    <div class="uk-margin-large-top">-->
<!--      <img src="../../assets/images/2-2.png">-->
<!--    </div>-->

<!--  </div>-->
<!--</div>-->


